import { render, staticRenderFns } from "./SquareButton.vue?vue&type=template&id=d9086f5a&scoped=true&"
var script = {}
import style0 from "./SquareButton.vue?vue&type=style&index=0&id=d9086f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9086f5a",
  null
  
)

export default component.exports